import React from "react";

export default function NewYearFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-2ne1{fill:none;stroke:#003f2e;stroke-miterlimit:10;stroke-width:8.96px}.cls-2ne3{fill:#eafefe}.cls-2ne4{fill:#003f2e}.cls-2ne6{fill:#f2673f}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_5"
          data-name="\u0421\u043B\u043E\u0439 5"
        >
          <path
            d="M304.74 496.61v583.03M1765.81 502.09v376.08"
            className="cls-2ne1"
          />
          <path
            d="M1727.37 847c-.54-8.28 5.71-15.19 13.05-15.66 7.94-.51 15.44 6.65 14.91 15.66"
            style={{
              strokeWidth: "2.95px",
              stroke: "#eafefe",
              strokeMiterlimit: 10,
              fill: "none",
            }}
          />
          <path
            d="M1766.56 886.42a107.9 107.9 0 0 0-50.43-.17l.16-26.42a14.24 14.24 0 0 1 12.42-14.12 101.1 101.1 0 0 1 10.33-.78 99.58 99.58 0 0 1 15 .78 14.24 14.24 0 0 1 12.49 14.12Z"
            className="cls-2ne3"
          />
          <path
            d="M1848.91 980.2c0 2.71-.1 5.39-.29 8.06s-.47 5-.83 7.49a106.92 106.92 0 0 1-212.71-15.55 108.52 108.52 0 0 1 1.31-16.84c.38-2.37.83-4.73 1.36-7.05.21-.91.42-1.8.66-2.69.58-2.3 1.24-4.56 2-6.8a106.09 106.09 0 0 1 6.44-15.41c1.12-2.18 2.31-4.3 3.56-6.4a106.91 106.91 0 0 1 197.38 39.47c.35 2.33.61 4.69.8 7.06.2 2.87.32 5.74.32 8.66Z"
            className="cls-2ne4"
          />
          <path
            d="M1848.62 988.26q-.28 3.78-.83 7.49c-7.08-3-13.32-12.48-19.86-22.37-6-9-13.4-20.25-18.79-20.27-5.39 0-12.89 11.17-18.92 20.15-8 11.92-15.59 23.2-24.68 23.2-9.11 0-16.61-11.38-24.56-23.38-6-9-13.4-20.25-18.79-20.27-5.38 0-12.88 11.15-18.91 20.13-8 11.94-15.59 23.21-24.69 23.21-9.1 0-16.6-11.37-24.56-23.39-4.83-7.3-10.61-16.06-15.51-19.14.58-2.3 1.24-4.56 2-6.8 6.87 3.27 13 12.47 19.33 22.11 6 9 13.39 20.25 18.79 20.27 5.4 0 12.89-11.16 18.92-20.13 8-11.94 15.6-23.22 24.68-23.22 9.12 0 16.62 11.38 24.56 23.39 6 9 13.4 20.26 18.79 20.28 5.4 0 12.9-11.17 18.93-20.14 8-11.93 15.59-23.21 24.68-23.21 9.11 0 16.61 11.37 24.55 23.38 4.6 7 10.12 15.33 14.87 18.71Z"
            className="cls-2ne3"
          />
          <path
            d="M487.08 385.15v178.58M1043.53 385.15v239.39"
            className="cls-2ne1"
          />
          <path
            d="M479.67 535.12a7.13 7.13 0 1 1 14.16 0"
            style={{
              strokeWidth: "1.49px",
              stroke: "#eafefe",
              strokeMiterlimit: 10,
              fill: "none",
            }}
          />
          <path
            d="M499.52 555.06A54.66 54.66 0 0 0 474 555l.08-13.38a7.2 7.2 0 0 1 6.29-7.15 51.67 51.67 0 0 1 5.22-.39 50.5 50.5 0 0 1 7.62.39 7.21 7.21 0 0 1 6.32 7.15Z"
            className="cls-2ne3"
          />
          <path
            d="M541.22 602.54a53.54 53.54 0 0 1-.57 7.88 53.51 53.51 0 0 1-5 16.06 54.15 54.15 0 0 1-97.27-.27c-.23-.47-.45-1-.67-1.43a54.38 54.38 0 0 1-4.09-30.78c.18-1.2.41-2.39.68-3.57.11-.46.22-.92.34-1.36.29-1.16.62-2.31 1-3.45a54 54 0 0 1 3.25-7.79 56.25 56.25 0 0 1 1.81-3.24 54.15 54.15 0 0 1 93.28.87c.37.63.72 1.28 1.06 1.93a49.71 49.71 0 0 1 2.18 4.67c.5 1.23 1 2.51 1.38 3.79a53.7 53.7 0 0 1 2 8.72c.17 1.17.31 2.37.4 3.58.16 1.47.22 2.92.22 4.39Z"
            className="cls-2ne6"
          />
          <path
            d="M538.6 585.87c-2 4-4 8.24-5.85 12.21-7.33 15.77-14.26 30.68-22.57 30.68-8.33 0-15.18-15-22.45-30.91-5.46-11.94-12.25-26.78-17.17-26.8-4.93 0-11.79 14.75-17.3 26.61-5.16 11.1-10.11 21.77-15.49 27.12a54.36 54.36 0 0 1-2.94-8.26c4.23-4.77 9.07-15.17 13.15-24 7.34-15.78 14.27-30.69 22.58-30.69 8.33.06 15.18 15 22.45 30.92 5.46 11.94 12.24 26.78 17.17 26.81 4.94 0 11.8-14.77 17.3-26.62 2.55-5.49 5-10.87 7.57-15.55a49.71 49.71 0 0 1 2.18 4.67c.49 1.25.96 2.53 1.37 3.81Z"
            className="cls-2ne3"
          />
          <path
            d="M287.6 1070.43c-.74-11.25 7.77-20.66 17.74-21.29 10.8-.69 21 9 20.28 21.29"
            style={{
              stroke: "#da5685",
              strokeWidth: "6.01px",
              strokeMiterlimit: 10,
              fill: "none",
            }}
          />
          <path
            d="M340.88 1124a146.8 146.8 0 0 0-68.56-.23l.22-35.92a19.34 19.34 0 0 1 16.89-19.19 136.46 136.46 0 0 1 34.48 0 19.37 19.37 0 0 1 17 19.2Z"
            className="cls-2ne4"
          />
          <path
            d="M452.87 1251.48a142.7 142.7 0 0 1-.82 15.41c-.31 3.07-.74 6.09-1.25 9.09a133.55 133.55 0 0 1-3.16 14.15c-.74 2.83-1.62 5.63-2.58 8.39a132.89 132.89 0 0 1-5.15 13c-.62 1.43-1.3 2.85-2 4.26a142.68 142.68 0 0 1-14.13 23q-1.89 2.54-3.9 5a145.93 145.93 0 0 1-20.21 20.17c-.26.24-.53.47-.8.68a145.27 145.27 0 0 1-183.13-.32c-1.21-1-2.39-2-3.56-3A146 146 0 0 1 176.7 1315q-3-6.15-5.4-12.62a141.5 141.5 0 0 1-7.31-27.54q-1-6-1.44-12.07c-.3-3.74-.45-7.5-.45-11.31 0-4.17.18-8.31.54-12.39.28-3.54.71-7 1.26-10.49.52-3.25 1.13-6.45 1.86-9.61.07-.32.14-.64.23-.94a138.7 138.7 0 0 1 5.95-19.16c.36-1 .75-2 1.18-2.94 1.49-3.69 3.17-7.29 5-10.8q2.29-4.44 4.84-8.69c.29-.48.57-1 .88-1.41a145.06 145.06 0 0 1 22-27.44 141.79 141.79 0 0 1 19.54-16.08 145.61 145.61 0 0 1 208.08 47.26 143.45 143.45 0 0 1 15.44 38.65q1.49 6.22 2.44 12.67c.48 3.17.83 6.38 1.08 9.61.08.9.15 1.81.2 2.74.16 3 .25 6.01.25 9.04Z"
            className="cls-2ne6"
          />
          <path
            d="M452.58 1242.46a1266.18 1266.18 0 0 1-144.25-48.15q-8.37-3.36-16.68-6.86-20.65-8.65-41.07-18.1-22.59-10.41-44.78-21.74a141.79 141.79 0 0 1 19.54-16.08q34.2 17.12 69.34 32 11.11 4.76 22.31 9.25 9.4 3.79 18.93 7.43c36.95 14.17 74.77 26.62 112.94 37.19q1.49 6.22 2.44 12.67c.48 3.17.83 6.38 1.08 9.61.08.94.15 1.85.2 2.78ZM452.05 1266.89c-.31 3.07-.74 6.09-1.25 9.09a133.55 133.55 0 0 1-3.16 14.15q-11.36.21-22.72.21-12.62 0-25.23-.25c-30.77-.6-61.55-2.35-92.05-5.2a1270.15 1270.15 0 0 1-145.09-22.1c-.3-3.74-.45-7.5-.45-11.31 0-4.17.18-8.31.54-12.39 37.44 8.13 75.41 14.51 113.45 19.12q16.85 2 33.7 3.62c30.63 2.87 61.53 4.58 92.45 5.13q24.95.45 49.81-.07ZM419.88 1343.69a145.93 145.93 0 0 1-20.21 20.17q-28.51-4.86-56.8-11-30.28-6.58-60.09-14.65c-1.45-.39-2.89-.79-4.33-1.2-36.11-9.87-72-21.45-107.15-34.57a141.5 141.5 0 0 1-7.31-27.54 1244.18 1244.18 0 0 0 124.83 41q27.26 7.37 55 13.48 32.1 7.14 64.6 12.53c3.82.57 7.63 1.19 11.46 1.78Z"
            className="cls-2ne3"
          />
          <path
            d="M439.91 1311.51c-.62 1.43-1.3 2.85-2 4.26a142.68 142.68 0 0 1-14.13 23q-7.66 1.63-15.37 3.1-32.64 6.39-65.54 11-20.13 2.85-40.28 5c-28.78 3.12-57.79 5.24-86.85 6.36-1.21-1-2.39-2-3.56-3a143.48 143.48 0 0 1-18.66-19.52c28.37-.62 56.74-2.21 84.93-4.76q10.85-1 21.65-2.13 21.86-2.35 43.71-5.55c32.19-4.63 64.36-10.56 96.1-17.76ZM421.77 1161.63c-28.39 7.2-57.08 13.44-85.85 18.62q-17.54 3.18-35.09 5.85c-3.07.46-6.11.91-9.18 1.35-37.17 5.35-74.75 9-112.37 11.07l-7.34.37c.36-1 .75-2 1.18-2.94 1.49-3.69 3.17-7.29 5-10.8q2.29-4.44 4.84-8.69c.29-.48.57-1 .88-1.41q33.44-1.92 66.77-5.7 22.12-2.49 44.1-5.78l2.67-.39c35.54-5.38 71-12.37 106.12-20.88a144.9 144.9 0 0 1 18.27 19.33Z"
            className="cls-2ne4"
          />
          <path
            d="M450.8 1276a133.55 133.55 0 0 1-3.16 14.15c-.74 2.83-1.62 5.63-2.58 8.39q-22.72-3.8-45.37-8.43c-33.78-6.91-67.32-15.22-100.27-24.82q-11.69-3.39-23.33-7.06a1249.826 1249.826 0 0 1-110.1-40.16 138.7 138.7 0 0 1 5.95-19.16c.36-1 .75-2 1.18-2.94 2 .87 4.11 1.73 6.16 2.57A1240.28 1240.28 0 0 0 305.91 1243c31.66 9.25 63.88 17.25 96.33 23.93q24.21 5.07 48.56 9.07Z"
            className="cls-2ne4"
          />
          <path d="M1599.98 399.22v233.92" className="cls-2ne1" />
          <path
            d="M1593.49 549.89a6.25 6.25 0 1 1 12.41 0"
            style={{
              strokeWidth: "2.18px",
              stroke: "#eafefe",
              strokeMiterlimit: 10,
              fill: "none",
            }}
          />
          <path
            d="M1610.89 567.37a48.1 48.1 0 0 0-22.39-.08l.07-11.72a6.32 6.32 0 0 1 5.52-6.27 43.83 43.83 0 0 1 11.25 0 6.33 6.33 0 0 1 5.55 6.27Z"
            className="cls-2ne6"
          />
          <path
            d="M1647.44 609a47.47 47.47 0 0 1-4.87 21c-.1.19-.19.38-.29.56-.44.87-.91 1.72-1.41 2.56a47.77 47.77 0 0 1-11 12.8 47.45 47.45 0 0 1-72.37-15.86c-.06-.1-.11-.2-.16-.3-.48-1-.92-2-1.33-3a46.75 46.75 0 0 1-2.64-9.08 47.63 47.63 0 0 1-.8-8.67 47.07 47.07 0 0 1 .59-7.47c.16-1.06.36-2.11.6-3.14a47.32 47.32 0 0 1 4-11c.47-.92 1-1.82 1.51-2.7l.07-.14a47.49 47.49 0 0 1 81.33 0l.45.75c.65 1.14 1.25 2.29 1.82 3.48.36.75.7 1.53 1 2.3a47.51 47.51 0 0 1 3 11c0 .23.06.46.09.69.11.81.2 1.62.26 2.45.1 1.2.15 2.47.15 3.77Z"
            className="cls-2ne3"
          />
          <path
            d="M1647.29 605.16c-.06-.83-.15-1.64-.26-2.45-.82.87-1.5 1.72-2.08 2.45a16 16 0 0 1-2.09 2.34 16.56 16.56 0 0 1-2.07-2.34c-2.4-3-6.4-8-14.48-8s-12.07 5-14.46 8a16.55 16.55 0 0 1-2.09 2.34 16 16 0 0 1-2.07-2.34c-2.4-3-6.41-8-14.48-8s-12.07 5-14.47 8a16 16 0 0 1-2.08 2.34 16.55 16.55 0 0 1-2.08-2.34c-2.39-3-6.4-8-14.48-8a16.15 16.15 0 0 0-6.38 1.23c-.24 1-.44 2.08-.6 3.14a47.07 47.07 0 0 0-.59 7.47 47.63 47.63 0 0 0 .8 8.67 26 26 0 0 0 4.71-4.84 18.46 18.46 0 0 1 2.07-2.34 17 17 0 0 1 2.09 2.34c2.4 3 6.4 8 14.47 8s12.08-5 14.47-8a16.92 16.92 0 0 1 2.08-2.33 16.29 16.29 0 0 1 2.08 2.33c2.4 3 6.41 8 14.47 8s12.08-5 14.48-8a17.71 17.71 0 0 1 2.07-2.34 17.69 17.69 0 0 1 2.09 2.34c2.4 3 6.4 8 14.46 8a17.36 17.36 0 0 0 3.16-.28 47.43 47.43 0 0 0 1.42-11.57c-.01-1.28-.06-2.55-.16-3.82Z"
            className="cls-2ne6"
          />
          <path
            d="M977.17 85.47 975.64 87a1.21 1.21 0 0 0-.31.49 1.11 1.11 0 0 0-.13.57 1.15 1.15 0 0 0 .13.58 1.11 1.11 0 0 0 .31.48 1.47 1.47 0 0 0 1.06.44h.4a1.44 1.44 0 0 0 .66-.39l1.53-1.53a1 1 0 0 0 .31-.48 1.06 1.06 0 0 0 .13-.58 1.08 1.08 0 0 0-.13-.58 1.14 1.14 0 0 0-.31-.48 1.5 1.5 0 0 0-1.06-.44l-.39.06a1.54 1.54 0 0 0-.67.38Z"
            className="cls-2ne4"
          />
          <rect
            width={1112.9}
            height={1112.9}
            x={487.08}
            y={609.67}
            rx={195.07}
            style={{
              fill: "#fff",
              strokeWidth: "20.18px",
              strokeMiterlimit: 10,
              stroke: "#003f2e",
            }}
          />
          <rect
            width={1707.48}
            height={115.31}
            x={189.79}
            y={385.15}
            className="cls-2ne4"
            rx={57.65}
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
